import { Phone, ShieldCheck, Globe } from 'lucide-react';

/**
 * Slim utility bar above the main header. Phone, trust signal, locale link.
 * Hidden on mobile (`MobileHeader` carries the same affordances).
 *
 *   <UtilityBar phone="1-833-INJURY-1" />
 */

export interface UtilityBarProps {
    phone: string;
    trustLabel?: string;
    locale?: string;
    onLocaleClick?: () => void;
    className?: string;
}

function telHref(number: string): string {
    return 'tel:' + number.replace(/[^0-9+]/g, '');
}

export function UtilityBar({
    phone,
    trustLabel = 'Free, confidential consultation · 24/7',
    locale = 'EN',
    onLocaleClick,
    className,
}: UtilityBarProps) {
    const cls = [
        'hidden md:flex items-center justify-between',
        'h-9 px-6 text-[12px] text-ink-soft',
        'bg-paper-deep border-b border-rule',
        className ?? '',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={cls}>
            <div className="flex items-center gap-4">
                <a
                    href={telHref(phone)}
                    className="inline-flex items-center gap-1.5 hover:text-ember-deep"
                    aria-label={`Call ${phone}`}
                >
                    <Phone size={12} aria-hidden="true" />
                    <span>{phone}</span>
                </a>
                <span className="inline-flex items-center gap-1.5 text-ink-mute">
                    <ShieldCheck size={12} aria-hidden="true" />
                    <span>{trustLabel}</span>
                </span>
            </div>
            <button
                type="button"
                onClick={onLocaleClick}
                className="inline-flex items-center gap-1.5 text-ink-mute hover:text-ink"
            >
                <Globe size={12} aria-hidden="true" />
                <span>{locale}</span>
            </button>
        </div>
    );
}

export default UtilityBar;
